import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { toast } from 'utils/toast';
import { InstanceService } from '_common/services';

import { clearSelection, removeFromList } from '_common/components/Table/TableSlice';

const SLICE_NAME = 'RECYCLE_PAGE';

// #region AsyncThunks
export const restoreObject = createAsyncThunk(
  `${SLICE_NAME}/restoreObject`,
  async ({ objectId }: { objectId: ObjectId }, thunkAPI) => {
    try {
      await new InstanceService({ errorsExpected: [403, 404] }).restoreRecycle(objectId);

      toast({
        variant: 'success',
        title: 'global.success',
        message: 'storage.notifications.restore.messageSuccess',
      });

      thunkAPI.dispatch(removeFromList({ identity: 'recycle', objectId }));
      thunkAPI.dispatch(clearSelection());
    } catch (error) {
      if (InstanceService.isAxiosError(error)) {
        switch (error?.response?.status) {
          case 403:
            toast({
              variant: 'error',
              title: 'global.error',
              message: 'storage.notifications.restore.insufficientPermissions',
            });
            break;
          case 404:
            toast({
              variant: 'error',
              title: 'global.error',
              message: 'storage.notifications.restore.missingOrignialLocation',
            });
            break;
        }
      }
    }
  },
);
// #endregion

// #region Selectors
// #endregion

// #region Slice
const RecyclePageSlice = createSlice({
  name: SLICE_NAME,
  initialState: {},
  reducers: {},
});

export default RecyclePageSlice.reducer;
// #endregion
